import { dataService } from '../services/dataService';

// Data management utility using API calls instead of localStorage
export const dataManager = {
  // Clear localStorage (keep for backward compatibility)
  clearAllData: () => {
    const keysToRemove = [
      'userProjects',
      'staffMembers', 
      'ticspl_events',
      'schemes',
      'eventRegistrations',
      'events_updated'
    ];
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    console.log('LocalStorage cleared - now using API calls');
  },

  // Initialize clean state (no-op since we use API)
  initializeCleanState: () => {
    console.log('Using API for data - no localStorage initialization needed');
  },

  // Create a new project for a user
  createProject: async (userId, projectData) => {
    try {
      const newProject = await dataService.createProject({
        name: projectData.name,
        project_type: projectData.type,
        investment_amount: projectData.investment,
        district: projectData.district,
        description: projectData.description || '',
        industry_type: projectData.industry_type || 'manufacturing'
      });
      return newProject;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },

  // Get projects for a specific user
  getUserProjects: async (userId) => {
    try {
      const projects = await dataService.getProjects();
      return projects.filter(project => project.entrepreneur === userId);
    } catch (error) {
      console.error('Error getting user projects:', error);
      return [];
    }
  }
};

// Initialize app with API-based approach
export const initializeApp = () => {
  // Clear localStorage on first run to force API usage
  const isFirstRun = !localStorage.getItem('api_initialized');
  
  if (isFirstRun) {
    dataManager.clearAllData();
    localStorage.setItem('api_initialized', 'true');
    console.log('App initialized with API-based data management');
  }
};